import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const getMonthName = (month) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[month - 1] || month;
};

const BirthsByMonthChart = ({ data, selectedYear, clinicName }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">
        Births by Month {selectedYear ? `(${selectedYear})` : '(All Years)'}
        {clinicName && (
          <span className="text-sm font-normal text-gray-600 block mt-1">
            {clinicName}
          </span>
        )}
      </h2>
      {data && data.length > 0 ? (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data.map(item => ({
            ...item,
            monthName: getMonthName(item.month)
          }))}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis 
              dataKey="monthName" 
              tick={{ fontSize: 11 }}
              stroke="#666"
            />
            <YAxis 
              tick={{ fontSize: 11 }}
              stroke="#666"
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#1f2937', 
                border: 'none', 
                borderRadius: '6px',
                color: '#fff'
              }}
              formatter={(value) => [value.toLocaleString(), 'Total Births']}
            />
            <Legend formatter={() => 'Total Births'} />
            <Bar dataKey="count" fill="#10B981" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="flex items-center justify-center h-[300px] text-gray-500">
          No data available
        </div>
      )}
    </div>
  );
};

export default BirthsByMonthChart;
